/** represents a pointer to memory */
export type Pointer<T = any> = {
    value: number;
    phantom: T;
    readonly __tag: unique symbol;
}

export const getPointer = (x: Uint8Array | Uint16Array | Uint32Array | Int8Array | Int16Array | Int32Array) => x.byteOffset as any as Pointer;

export const NullPointer = 0 as any as Pointer;
